module.exports = __webpack_public_path__ + "img/update.2b7ac521.svg";